(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('#Selected-Collection-Slider .selected-collection-swiper-container', {
      slidesPerView: window.innerWidth < 900 ? 1 : 4,
      spaceBetween: window.innerWidth < 900 ? 0 : 20,
      loop: true,
      pagination: {
        el: ' .swiper-pagination',
        clickable: true,
      },
      autoHeight: false,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.accordion__button').forEach((button) => {
    button.addEventListener('click', () => {
      const accordion = button.closest('.accordion');
      const isActive = accordion.classList.contains('is-active');

      // Close all accordions
      document.querySelectorAll('.accordion').forEach((acc) => {
        acc.classList.remove('is-active');
        acc.querySelector('.accordion__button').setAttribute('aria-expanded', 'false');
      });

      // Open clicked accordion if it wasn't already open
      if (!isActive) {
        accordion.classList.add('is-active');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
